// removed by extract-text-webpack-plugin
module.exports = {"section":"_1o8zrXtGPEccNJMsWKamyr","instructions":"_1B9xf1-sSmvyQXA4zej4ev","text":"_3iOCyEp9YRpHERpBxkLz24","view":"_1unvt8tR-_h12XDhrC9Ke9","image":"_3Gf1BQj1zRvruchxremluX","imageContainer":"_1G_xHRXZY4i0oifUiX5y4v"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/MassiveUpload/Instructions/styles.css
// module id = 2740
// module chunks = 0